import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* LIBRARIES */
import * as React from 'react';
import classNames from 'classnames';
import { isEmpty, pick } from 'ramda';
/* MODULES */

import { getCustomClasses, getInlineStyles, getStylesClasses } from './helpers';
/* STYLES */

import * as stylesModule from './button.css';
/* TYPES */

import { LoaderIcon } from '../icons/loader';
/* CONSTANTS */

export var HANDLERS_ARRAY = [// Mouse events
'onMouseEnter', 'onMouseLeave', 'onMouseDown', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', // Mouse events
'onTouchEnd', 'onTouchStart'];
/* CONSTANTS */

export var BUTTON_CUSTOM_TYPE = {
  primary: 'primary',
  secondary: 'secondary',
  flat: 'flat'
};
/* TYPES */

export * from './types';
export var Button =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Button, _React$PureComponent);

  function Button() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Button);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Button)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var _props$custom = props.custom,
          custom = _props$custom === void 0 ? {} : _props$custom;

      if (props.onClick && !custom.disabled) {
        props.onClick(event);
      }
    });

    return _this;
  }

  _createClass(Button, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          _this$props$__attribu = _this$props.__attributes,
          __attributes = _this$props$__attribu === void 0 ? {} : _this$props$__attribu,
          _this$props$__classNa = _this$props.__classNames,
          __classNames = _this$props$__classNa === void 0 ? '' : _this$props$__classNa,
          children = _this$props.children,
          _this$props$dataMark = _this$props.dataMark,
          dataMark = _this$props$dataMark === void 0 ? 'Button' : _this$props$dataMark,
          _this$props$styles = _this$props.styles,
          styles = _this$props$styles === void 0 ? {} : _this$props$styles,
          _this$props$custom = _this$props.custom,
          custom = _this$props$custom === void 0 ? {} : _this$props$custom;

      var handlers = _objectSpread({}, pick(HANDLERS_ARRAY, this.props), {
        onClick: this.handleClick
      });

      return React.createElement("button", _extends({
        "data-mark": dataMark,
        className: classNames(stylesModule['container'], (_classNames = {}, _defineProperty(_classNames, getCustomClasses(custom), !isEmpty(custom)), _defineProperty(_classNames, getStylesClasses(styles), !isEmpty(styles)), _classNames), __classNames),
        style: getInlineStyles(this.props)
      }, __attributes, handlers), custom.loading ? React.createElement("div", {
        className: stylesModule['icon']
      }, React.createElement(LoaderIcon, {
        custom: {
          size: '16'
        },
        styles: {
          color: custom.loaderIconColor
        }
      })) : null, React.createElement("span", {
        className: classNames(stylesModule['content'], _defineProperty({}, stylesModule['content-loading'], custom.loading))
      }, children));
    }
  }]);

  return Button;
}(React.PureComponent);